import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useConfig } from 'wagmi'

import { useConnectedAddress } from '@/domain/wallet/useConnectedAddress'
import { canWalletBatchQueryFn, canWalletBatchQueryKey } from '@/features/actions/logic/useCanWalletBatch'

export function usePrefetchCanWalletBatchQuery(): void {
  const config = useConfig()
  const queryClient = useQueryClient()
  const { account, chainId, connector } = useConnectedAddress({ throwOnNotConnected: false })

  useEffect(() => {
    if (!account) return
    void queryClient.prefetchQuery({
      queryKey: canWalletBatchQueryKey({ account, chainId, connector }),
      queryFn: async () => await canWalletBatchQueryFn({ account, chainId, config }, { throwOnError: true }),
      initialData: { canWalletBatch: false },
      staleTime: 0,
    })
  }, [queryClient, config, account, chainId, connector])
}
